export const appEN = {
  'activities': {
    'cycling': 'Cycling',
    'hiking': 'Hiking',
    'running': 'Running',
    'skitouring': 'Skitouring',
    'walking': 'Salking',
    'asphalt': 'Asphalt',
    'bitumenduro': 'Bitumen hard',
    'onoff': 'Onoff',
    'real_dirt': 'Real dirt',
    'bar': 'Bar',
    'real-dirt': 'Real dirt'
  },
  'sidemenu': {
    'project': 'The project',
    'offline': 'Offline',
    'settings': 'Settings',
    'credits': 'Credits',
    'disclaimer': 'Disclaimer'
  },
  'components': {
    'cardtrack': {
      'delete': 'Delete',
      'remove': 'Remove'
    },
    'map': {
      'btnrec': {
        'slide': 'Swipe to register'
      },
      'register': {
        'cancel': 'Cancel',
        'photo': 'Photo',
        'title': 'Record',
        'track': 'Track',
        'vocal': 'Voice note',
        'waypoint': 'Waypoint'
      }
    },
    'searchbar': {
      'filters': 'Filter by',
      'nofilters': 'No filter matches your search',
      'noplaces': 'No place matches to the research carried out',
      'notracks': 'No paths matches to the research carried out',
      'placeholder': 'Search',
      'places': 'Places',
      'tracks': 'Tracks'
    },
    'slopechart': {
      'slope': {
        'label': 'slope'
      },
      'surfaces': {
        'asphalt': {
          'label': 'asphalt'
        },
        'concrete': {
          'label': 'concrete'
        },
        'dirt': {
          'label': 'land'
        },
        'grass': {
          'label': 'grass'
        },
        'gravel': {
          'label': 'gravel'
        },
        'paved': {
          'label': 'paved'
        },
        'sand': {
          'label': 'sand'
        }
      }
    }
  },
  'generic': {
    'cancel': 'Cancel',
    'confirm': 'Confirm',
    'delete': 'Delete',
    'error': 'An error has occurred. Try later',
    'hour': 'h',
    'minute': 'min',
    'ok': 'ok',
    'retry': 'Retry',
    'warning': 'Warning'
  },
  'modals': {
    'coin': {
      'buttonall': 'See all coin packs',
      'buttonone': 'Buy 1 Coin / 1€',
      'defaultmessage': 'Buy coins to download offline content',
      'info1': 'You can purchase a single route',
      'info2': 'You have everything available even without coverage',
      'info3': 'Receive proximity notifications',
      'subinfo1': 'Buy a single coin for € 1',
      'subinfo2': 'Precise navigation even when you are offline',
      'subinfo3': 'We warn you when you are close to points of interest along the route'
    },
    'giftcoin': {
      'button': 'Start exploring',
      'info': 'You immediately get 2 webmapp coins as a gift to download offline content!',
      'title': 'Welcome to webmapp!'
    },
    'login': {
      'email': 'E-mail',
      'errors': {
        '401': 'The credentials you entered are incorrect. Please check your email and password and try again',
        'form': {
          'emailInvalid': 'You have entered an invalid email',
          'emailRequired': 'Email is required',
          'passwordRequired': 'Password is required'
        },
        'generic': 'Oops! Something went wrong! Wait a few minutes and try again.'
      },
      'forgotPassword': 'Did you forget your password?',
      'login': 'Login',
      'message': 'Log in with your credentials to continue.',
      'password': 'Password',
      'rememberLogin': 'Remember your credentials',
      'title': 'Login',
      'welcome': 'Welcome!'
    },
    'photo': {
      'next': 'Next',
      'popover': {
        'cancel': 'Cancel',
        'library': 'From the library',
        'shot': 'Take a picture',
        'title': 'Source of the image'
      },
      'save': {
        'addphoto': 'Add photos',
        'formphototitle': 'Title',
        'formtitle': 'Give your photos a title',
        'modalconfirm': {
          'cancel': 'Cancel',
          'confirm': 'Yes, delete',
          'text': 'If you delete it it will not be added to this recording',
          'title': 'Are you sure you want to delete this photo from the recording?'
        },
        'placeholder': 'Here you can enter a title',
        'savebtn': 'Save',
        'title': 'Record photos'
      },
      'single': {
        'formphototitle': 'Title',
        'placeholder': 'Here you can enter a title',
        'savebtn': 'Done',
        'title': 'Edit photos'
      }
    },
    'settings': {
      'alert': {
        'logout': 'Are you sure you want to disconnect your account?'
      },
      'logout': 'Log out',
      'title': 'Settings',
      'version': 'Version'
    },
    'storesuccess': {
      'back': 'Back to search',
      'buttondownload': 'Download now',
      'continue': 'You want to use your Coin immediately to download',
      'continue2': '?',
      'info': 'You can check the balance of your coins directly in your personal area!',
      'or': 'Or',
      'title': 'Thank you for purchasing your first coin!'
    },
    'success': {
      'photos': {
        'text': 'Your photos have been successfully saved. You can view them by accessing your profile.',
        'title': 'Photos successfully recorded!'
      },
      'return': 'Go back to explore',
      'track': {
        'avgspeed': 'Average speed',
        'odo': 'Km traveled',
        'slope': 'Slope',
        'text': 'The track was saved successfully. You can view it by logging into your profile.',
        'time': 'Time',
        'title': 'Successfully registered activity!',
        'topspeed': 'Full speed'
      },
      'waypoint': {
        'text': 'You have successfully saved your waypoint. You can view it by logging into your profile.',
        'title': 'Waypoint successfully registered!'
      }
    }
  },
  'pages': {
    'downloadlist': {
      'cancel': 'Cancel',
      'deleteselected': 'Delete selected',
      'nodata': "You haven't downloaded any tracks yet",
      'nodata2': 'With the contents for offline use you can browse in peace even without a connection!',
      'nodatabtn': 'Explore',
      'select': 'Select',
      'title': 'Downloads'
    },
    'favourites': {
      'nodata': 'There are no favorite heart tracks, click on a track icon to add it to this list',
      'title': 'Favourites'
    },
    'home': {
      'button': 'Choose a starting point',
      'closerTracks': 'Routes nearby',
      'intro': "Let's plan your next adventure together",
      'mostViewedTracks': 'Most viewed routes',
      'nocloserTracks': 'There do not appear to be any paths near the current location',
      'welcome': 'Welcome!'
    },
    'itinerary': {
      'btnFullMapExpand': 'Expand',
      'btnFullMapReduce': 'Reduce',
      'btndnavigate': 'Navigate',
      'btndownload': 'Download',
      'btnfavourite': 'Favourite',
      'btnshare': 'Share',
      'description': {
        'description': 'Description',
        'gallery': 'Gallery'
      },
      'detail': {
        'from': 'Start',
        'to': 'Finish',
        'ascent': 'Slope +',
        'descent': 'Slope -',
        'distance': 'Distance',
        'ele_from': 'Starting altitude',
        'ele_max': 'Maximum altitude',
        'ele_min': 'Minimum altitude',
        'ele_to': 'Ending altitude'
      },
      'directions': 'Get directions',
      'download': 'Download',
      'downloadpanel': {
        'complete': 'Download completed',
        'dontclose': 'Do not close the application during the data installation phase',
        'downdata': 'Data download',
        'downsize': 'Download size',
        'download': 'Download',
        'downloadbtn': 'Download',
        'downloading': 'Downloading',
        'downmap': 'Map download',
        'downmedia': 'Media downloads',
        'downsetup': 'Initial setup',
        'gotobtn': 'Go to my downloads',
        'install': 'Installation'
      },
      'favbtn': {
        'isFavourite': 'Added to favorites!',
        'isNotFavourite': 'Removed from favorites!'
      },
      'modalconfirm': {
        'cancel': 'Cancel',
        'confirm': 'Exit',
        'text': 'Exit without finishing the track download?',
        'title': 'Stop downloading?'
      },
      'modalNotImpemented': {
        'text': 'Comming soon',
        'title': 'Currently not available',
        'confirm': 'ok'
      },
      'navigate': 'Navigate',
      'share': 'Share',
      'tabdescription': 'Description',
      'tabdetail': 'Details',
      'tabeat': 'Where to eat',
      'tabhowto': 'How to get',
      'tabviability': 'Viability',
      'tabwalkable': 'Accessibility',
      'viability': {
        'info': 'More info',
        'title': 'Practicability of the route'
      }
    },
    'map': {
      'loading': 'Research in progress...',
      'recordingbtn': 'Record in progress ...',
      'searchherebtn': 'Search in this area'
    },
    'photodetail': {
      'delete': 'Delete registration',
      'edit': 'Change registration',
      'title': 'Photo recorded'
    },
    'photolist': {
      'noitem': 'There are currently no recorded photos',
      'title': 'Recorded photos'
    },
    'profile': {
      'title': 'Profile',
      'lang': 'Language',
      'langPlaceholder': 'select',
      'projectlink': 'Project',
      'disclaimerlink': 'Disclaimer',
      'creditslink': 'Credits',
      'privacylink': 'Privacy',
      'data': {
        'data': 'Data usage',
        'downloads': 'Downloads',
        'tracks': 'Downloaded tracks'
      },
      'loggedOut': {
        'login': 'Sign in',
        'signup': 'Sign up',
        'slides': {
          '0': 'Access and download your favorite routes',
          '1': 'You can also share them with your travel companions'
        }
      },
      'records': {
        'photos': 'Photos',
        'title': 'Records',
        'tracks': 'Tracks',
        'vocals': 'voice notes',
        'waypoints': 'Waypoints'
      }
    },
    'register': {
      'averagespeed': 'Average speed',
      'backgroundbtn': 'Record in the background',
      'currentspeed': 'Current speed',
      'modalconfirm': {
        'cancel': 'Cancel',
        'confirm': 'Confirm',
        'text': 'Once confirmed, you will no longer be able to resume this navigation',
        'title': 'Do you confirm that you want to end the registration?'
      },
      'modalexit': {
        'cancel': 'Cancel',
        'confirm': 'Delete',
        'text': 'By completing the action, the track will be deleted from your profile and from Webmapp. The operation cannot be canceled.',
        'title': 'Delete forever?'
      },
      'modalphotos': {
        'deselectall': 'Uncheck all',
        'noimages': 'There are no images taken while recording the route',
        'savebtn': 'Load',
        'selectall': 'Select all',
        'title': 'Upload photos'
      },
      'modalsave': {
        'closemodal': {
          'back': 'Back to registration',
          'cancel': 'Cancel',
          'delete': 'Delete registration'
        },
        'deletebtn': 'QUIT WITHOUT SAVING',
        'formactivity': 'Kind of activity',
        'formactivityerror': 'The type of business is a required field',
        'formactivityplaceholder': 'Select',
        'formdescription': 'Description',
        'formdescriptionplaceholder': 'If you want you can add a description',
        'formphotos': 'Add photos taken along the way',
        'formtitle': 'Track title',
        'formtitleerror': 'The title field is required',
        'formtitleplaceholder': 'Enter a title',
        'phototextshort': 'Photo',
        'savebtn': 'Save',
        'title': 'Save track',
        'titleEdit': 'Edit track'
      },
      'odo': 'Km traveled',
      'pausebtn': 'Pause',
      'resumebtn': 'Resume',
      'stopbtn': 'Finish',
      'title': 'Record a track'
    },
    'registeruser': {
      'cf': 'Fiscal Code',
      'cfextra': 'Why do we ask you for the CF?',
      'cfph': 'XXXXXXXXXXXXXXXX',
      'cfpopovermessage': 'If you are a CAI Member, enter your CF when registering. For you, the download of the stages of the Sentiero Italia CAI will be automatically free!',
      'cfpopovertitle': 'Why do we ask you for the CF?',
      'confirmPassword': 'Confirm password',
      'confirmPasswordph': 'Repeat the password',
      'email': 'Email',
      'emailph': 'example@email.com',
      'errors': {
        'form': {
          'nameRequired': 'A name must be entered'
        },
        'form.cfInvalid': 'The fiscal code is not valid',
        'form.confirmPasswordInvalid': 'The confirmation does not match the password entered above',
        'form.confirmPasswordRequired': 'Password confirmation is required',
        'form.emailInvalid': 'The email is invalid',
        'form.emailRequired': 'It is necessary to insert an email',
        'form.passwordRequired': 'A password must be entered'
      },
      'genericError': 'Error during user registration',
      'loading': 'Registration in progress',
      'name': 'Name',
      'nameph': 'Insert your name',
      'password': 'Password',
      'passwordph': 'enter password',
      'privacy1': "By clicking on \"Register\" you accept our ",
      'privacy2': 'e i',
      'privacy3': '',
      'privacylink1': 'Privacy Policy',
      'privacylink2': 'Terms and conditions',
      'registerbutton': 'Register',
      'title': 'Join the webmapp community!'
    },
    'route': {
      'btnFullMapExpand': 'Expand',
      'btnFullMapReduce': 'Reduce',
      'btndnavigate': 'Navigate',
      'btndownload': 'Download',
      'btnfavourite': 'Favourite',
      'btnshare': 'Share',
      'description': {
        'description': 'Description',
        'gallery': 'Gallery'
      },
      'detail': {
        'from': 'Start',
        'to': 'Finish',
        'ascent': 'Slope +',
        'descent': 'Slope -',
        'distance': 'Distance',
        'ele_from': 'Starting elevation',
        'ele_max': 'Max elevation',
        'ele_min': 'Min elevation',
        'ele_to': 'Finishing elevation',
        'difficulty': 'Difficulty',
        'duration_forward': 'outward duration',
        'duration_backward': 'return duration'
      },
      'directions': 'Get directions',
      'download': 'Download',
      'downloadpanel': {
        'complete': 'Download completed',
        'dontclose': 'Do not close the application during the data installation phase',
        'downdata': 'Data download',
        'downsize': 'Download size',
        'download': 'Download',
        'downloadbtn': 'Download',
        'downloading': 'Downloading',
        'downmap': 'Map download',
        'downmedia': 'Media downloads',
        'downsetup': 'Initial setup',
        'gotobtn': 'Go to my downloads',
        'install': 'Installation'
      },
      'favbtn': {
        'isFavourite': 'Added to favorites!',
        'isNotFavourite': 'Removed from favorites!'
      },
      'modalconfirm': {
        'cancel': 'Cancel',
        'confirm': 'Exit',
        'text': 'Exit without finishing the track download?',
        'title': 'Stop downloading?'
      },
      'navigate': 'Navigate',
      'share': 'Share',
      'tabdescription': 'Description',
      'tabdetail': 'Dettagli',
      'tabeat': 'Dove mangiare',
      'tabhowto': 'Come arrivare',
      'tabviability': 'Viability',
      'tabwalkable': 'Accessibility',
      'viability': {
        'info': 'Other info',
        'title': 'Practicability of the route'
      }
    },
    'store': {
      'button1': '1 Coin',
      'button100': 'Pack 100 coins',
      'button20': ' Pack 20 Coins',
      'button50': 'Pack 50 coins',
      'main': 'Webmapp Coins',
      'text': 'You can buy a single Coin, or choose from one or more packages!',
      'text2': 'Coins are used to download routes and offline content, and access numerous benefits!',
      'title': 'Store'
    },
    'trackdetail': {
      'avgspeed': 'Average speed',
      'delete': 'Delete registration',
      'details': 'Details',
      'distance': 'Km traveled',
      'edit': 'Change registration',
      'photos': 'Photo',
      'slope': 'Slope',
      'time': 'Time',
      'title': 'Track recorded',
      'topspeed': 'Full speed'
    },
    'tracklist': {
      'noitem': 'There are currently no recorded tracks',
      'title': 'Tracks recorded'
    },
    'waypoint': {
      'here': 'You are here',
      'modalsave': {
        'formdescription': 'Description',
        'formdescriptionplaceholder': 'If you want you can add a description',
        'formoptional': 'Optional',
        'formphotos': 'Add photos of the Waypoint',
        'formtitle': 'Waypoint title',
        'formtitleerror': 'Waypont title required',
        'formtitleplaceholder': 'Enter a title',
        'formtype': 'Waypoint type',
        'formtypeerror': 'Type of waypoint required',
        'formtypeplaceholder': 'Select',
        'phototextshort': 'photo',
        'save': 'Save ',
        'title': 'Register a waypoint'
      },
      'save': 'Save waypoint',
      'title': 'Register a waypoint'
    },
    'waypointdetail': {
      'delete': 'Delete registration',
      'edit': 'Change registration',
      'title': 'Waypoint recorded'
    },
    'waypointlist': {
      'noitem': 'There are currently no registered waypoints',
      'title': 'Recorded waypoints'
    },
    'project': {
      'title': 'The Project'
    },
    'credits': {
      'title': 'Credits',
      'webmappContent1': 'The app {{appName}} is developed and mantained by Webmapp.<br> Webmapp creates web, mobile and printed maps for Nature & Adventure Tourism.<br>For more information please visit our website ',
      'webmappContent2': " or contact us at <a href=\"mailto:info@webmapp.it\">info@webmapp.it</a>",
      'map': 'Map',
      'mapContent': '© Webmapp, distributed with licence CC BY-NC-SA',
      'cartographicData': 'Cartographic Data',
      'cartographicDataContent': '© OpenStreetMap Contributors'
    },
    'disclaimer': {
      'title': 'Disclaimer',
      'content': 'Hiking and, more generally, outdoor activity, is a potentially risky activity: before setting out on a hike, make sure you have the knowledge and skills to do it. If you are not sure, contact local experts who can help, suggest and support you in planning and carrying out your activities. The data presented on this APP cannot fully guarantee the risk-free practicability of the route: changes, even important ones, may have occurred since the last verification of the route itself. It is therefore essential that those who are preparing to carry out activities carefully evaluate the opportunity to continue on the basis of the suggestions and advice contained in this APP, based on their experience, on the weather conditions (even in the previous days) and on an evaluation in the field at the beginning of the activity. Webmapp S.r.l. does not provide guarantees on the safety of the places described and assumes no responsibility for any damage caused by carrying out the activities described.'
    }
  },
  'Layers': 'Layers',
  'Sentieri': 'Trails',
  'Non ci sono cammini preferiti, clicca sull\'icona cuore di un cammino per aggiungerlo a questa lista':
    'There are no favorite paths, click on the heart icon of a path to add it to this list',
  'services': {
    'geolocation': {
      'notification': {
        'text': {
          'newTrackRecord': 'Tap the notification to open the app'
        },
        'title': {
          'newTrackRecord': 'Registration in progress'
        }
      }
    },
    'share': {
      'dialogTitle': 'Share with your friends',
      'text': 'Here is an interesting webmapp path',
      'title': 'Have you seen this path?',
      'url': 'www.webmapp.it'
    }
  },
  'tabs': {
    'favourites': 'favorites',
    'home': 'home',
    'map': 'map',
    'profile': 'profile'
  },
  'Percorribilità': 'Viability',
  'no-tracks': "You haven't downloaded any tracks yet",
  'I tuoi dati': 'Your data',
  'Le tue registrazioni': 'your recordings',
  'Descrizione Audio': 'Audio Description',
  'Punto di interesse nelle vicinanze': 'Point of interest nearby',
  'elimina': 'delete',
  'Attenzione': 'Attention',
  'Azione irreversibile': 'Irreversible action',
  'Vuoi veramente eliminare il tuo account?': 'Do you really want to delete your account?',
  'Annulla': 'Cancel',
  'massima precisione ogni 5 metri viene rilevata la posizione, consumo consistente della batteria': 'maximum precision every 5 meters the position is detected, consistent battery consumption',
  'media precisione ogni 10 metri viene rilevata la posizione, consumo medio della batteria': 'medium precision every 10 meters the position is detected, average battery consumption',
  'minima precisione ogni 20 metri viene rilevata la posizione, consumo minore della batteria': 'minimum precision every 20 meters the position is detected, lower battery consumption',
  'la distanza espressa in metri che indica la cadenza di rilevamento posizione, più il distance filter è minore piu il consumo della batteria sarà maggiore.': 'the distance expressed in meters which indicates the cadence of position detection, the lower the distance filter, the higher the battery consumption will be.',
  'PAGINE': 'PAGES',
  'metri': 'meters',
  'precisione su mezzi di locomozione, consumo minimo della batteria': 'precision on means of transport, minimum battery consumption',
  'rimani acceso': 'stay lit',
  'forza il dispositivo a non spegnersi': 'forces the device not to turn off',
  'asphalt': 'Asphalt',
  'bitumenduro': 'Bitumenduro®',
  'real_dirt': 'Real dirt',
  'bar': 'Bar',
  'onoff': 'Onoff',
  'mountain_passes': 'Mountain passes',
  'roads_to_drive': 'Roads to drive (BLUE)',
  'points_of_interest': 'Points of interest (GREEN)',
  'dirt_roads': 'Dirt roads (ORANGE)',
  'streets_to_admire': 'Accommodation facilities (PINK)',
  'other': 'Other types of Point of interest',
  'description': 'Description',
  'share_ugcpoi': 'Do you want to propose your waypoint on the motomappa?',
  'no': 'No',
  'yes': 'Yes',
  'duration': 'Duration',
  'MEMORIA': 'MEMORY',
  'resetta la memoria': 'reset memory',
  'sei sicuro di voler cancellare cache e dati  salvati?': 'are you sure you want to delete saved cache and data?',
  'Elimina account': 'Delete account',
  'Conferma': 'Confirm',
  'Link utili': 'Useful links',
  "Per registrare tracce e poi correttamente, abilita l'autorizzazione alla posizione nelle impostazioni": 'To record tracks and display them correctly, enable the location permission in the settings',
  'Apri impostazioni App': 'Open app settings',
  'Ti trovi qui': 'You are here',
  'Salva Waypoint': 'Save Waypoint',
  'Salva Traccia': 'Save track',
  'Impossibile caricare i cammini preferiti, riprova':
    'Unable to load favorite paths, please try again',
  'Cancella': 'Delete',
  'ATTENZIONE': 'WARNING',
  'Foto correttamente cancellata': 'Photo successfully deleted',
  'Traccia correttamente cancellata': 'Track successfully deleted',
  'Waypoint correttamente cancellato': 'Waypoint successfully deleted',
  'Sei sicuro di voler cancellare questa foto?': 'Are you sure you want to delete this photo?',
  'Sei sicuro di voler cancellare questa traccia?': 'Are you sure you want to delete this track?',
  'Sei sicuro di voler cancellare questo waypoint?': 'Are you sure you want to delete this waypoint?',
  'Scarica il tracciato GPX': 'Download the GPX track',
  'Scarica il tracciato KML': 'Download the KML track',
  'Scarica il tracciato GEOJSON': 'Download the GEOJSON track',
  'real-dirt': 'Real dirt',
  'privacy': {
    'agree': {
      'title': 'Data Processing',
      'message': 'I consent to my data being published',
      'read_privacy': 'Read data processing information',
      'accept': 'Accept',
      'reject': 'Reject',
      'confirm': {
        'title': 'Confirm change',
        'accept_message': 'Are you sure you want to accept data processing?',
        'reject_message': 'Are you sure you want to reject data processing?',
        'yes': 'Yes, confirm',
        'no': 'Cancel'
      },
      'final_confirm': {
        'title': 'Change completed',
        'accept_message': 'Data processing consent has been successfully accepted.',
        'reject_message': 'Data processing consent has been successfully rejected.',
        'ok': 'OK'
      }
    }
  }
};
